/* eslint-disable */

import React from "react"
import utf8 from "utf8"
import { createLinks } from './Links'

// display/Generate main news here
export const GenerateMainAlert = (data, companyInfo={}, type) => {    
    let style = (type == 'main') ? "own" : 'industry'
    
    let linksDiv = ""
    let printDiv = ""
    let onlineDiv = ""
    let tv_radioDiv = ""

    let linksLength = 0
    let printLength = 0
    let onlineLength = 0
    let tv_radioLength = 0

    // if links exists
    if (typeof data.link === 'object') {
        linksDiv = createLinks(data.link.info)
        linksLength = data.link.info.length
    }
    
    // if print exists
    if (typeof data.print === 'object') {
        printDiv = createLinks(data.print.info)
        printLength = data.print.info.length
    }
    
    // if online links exists
    if (typeof data.online === 'object') {
        onlineDiv = createLinks(data.online.info)
        onlineLength = data.online.info.length
    }

    // if tv/radio links exists
    if (typeof data.tv_radio === 'object') {
        tv_radioDiv = createLinks(data.tv_radio.info)
        tv_radioLength = data.tv_radio.info.length
    }
    
    // check is image exists on main section
    let img_exists = (typeof data.main_img === 'string' && data.main_img.length !=0) ? true : false
    // make row width adjust if image is exists
    let row_will_be = (img_exists) ? 'col-md-9' : 'col-md-12'
    

    return (
        <div className={`pb-4 ${style}`} >
            <div style={{textAlign: "right"}}>
                <span style={{background: '#0091d2', color:"#fff", padding: "1rem"}}>
                    {(companyInfo.logo) ? (
                        <img src={companyInfo.logo} style={{width:"15px", height:"15px", marginRight: '0.5rem'}} />
                    ) : ''  }
                    {companyInfo.name}
                </span>
            </div>
            <hr/>

            <div>
                <h6>{utf8.decode(data.title)}</h6>
            </div>

            {/* if synopsis exists then print */}
            {(data.synopsis)?(
                <div className="row">
                    <div className={`${row_will_be} pt-4`}>
                        <strong>Synopsis : </strong>
                        {data.synopsis}
                    </div>
                    {(img_exists)?(
                        <div className="col-md-3 pt-4">
                            <img src={data.main_img} style={{width:"100%"}}/>
                        </div>
                    ) : "" }
                </div>
            ) : '' }

            {/* if synopsis exists then print */}
            {(data.synopsis2)?(
                <div className="pt-4">
                    {data.synopsis2}
                </div>
            ) : '' }
            
            {/* Its shows when links exists */}
            { (linksLength > 0) ? (
                <div className="row">
                    <div className="col-md-3 py-2">
                        <b className="btn btn-success btn-sm">
                            Links &nbsp; &nbsp; &rarr; &nbsp; &nbsp; {linksLength}
                        </b>
                    </div>
                    <div className="col-md-9 py-2">{linksDiv}</div>
                </div>
            ) : '' }

            {/* Its shows when print exists */}
            { (printLength > 0) ? (
                <div className="row">
                    <div className="col-md-3 py-2">
                        <b className="btn btn-success btn-sm">
                            Print Source &nbsp; &nbsp; &rarr; &nbsp; &nbsp; {printLength}
                        </b>
                    </div>
                    <div className="col-md-9 py-2">{printDiv}</div>
                </div>
            ) : '' }
            
            {/* Its shows when online exists */}
            { (onlineLength > 0) ? (
                <div className="row">
                    <div className="col-md-3 py-2">
                        <b className="btn btn-success btn-sm">
                            Online Source &nbsp; &nbsp; &rarr; &nbsp; &nbsp; {onlineLength}
                        </b>
                    </div>
                    <div className="col-md-9 py-2">{onlineDiv}</div>
                </div>
            ) : '' }

            {/* Its shows when tv/radio exists */}
            { (tv_radioLength > 0) ? (
                <div className="row">
                    <div className="col-md-3 py-2">
                        <b className="btn btn-success btn-sm">
                            Tv/Media Source &nbsp; &nbsp; &rarr; &nbsp; &nbsp; {tv_radioLength}
                        </b>
                    </div>
                    <div className="col-md-9 py-2">{tv_radioDiv}</div>
                </div>
            ) : '' }

        </div>)
}

